import { BooleanField, ReferenceManyField, Tab, TabProps, TextField } from 'react-admin';
import { CheckRecordActiveSwitch } from '@/pages/Candidate/view/utils';
import { FCRAWorkerCheckRecordTypeEnum, TurnReferencesEnum, TurnTargetsEnum } from '@/types/turn-enums';
import { MainDatagridStyled } from '@/styles/overrides';
import { path } from './constants';

export const WatchlistRecordsTab = (props: Partial<TabProps>) => {
  return (
    <Tab label="Watchlist" {...props}>
      <ReferenceManyField
        reference={TurnReferencesEnum.Candidates}
        target={TurnTargetsEnum.WorkerWatchlistRecords}
        label=""
        {...props}
      >
        <MainDatagridStyled bulkActionButtons={false} rowClick={false} sx={{ width: 'max-content' }}>
          <CheckRecordActiveSwitch type={FCRAWorkerCheckRecordTypeEnum.Watchlist} />
          <TextField emptyText="false" sortable={false} source={path('active')} />
          <TextField label="Criminal Version" sortable={false} source={path('criminal_version')} />
          <TextField label="ID" source={path('id')} />
          <BooleanField label="Records Match" source={path('records_match')} />
          <TextField label="Report Token" sortable={false} source={path('report_token')} />
          <TextField label="Address ID" source={path('address_id')} />
          <TextField label="Address Remarks" source={path('address_remarks')} />
          <TextField label="Alias Name" source={path('alias_name')} />
          <TextField label="Alias Type" source={path('alias_type')} />
          <TextField label="Call Sign" source={path('call_sign')} />
          <TextField label="Citizenship" source={path('citizenship')} />
          <TextField label="Constituancy" source={path('constituancy')} />
          <TextField label="Country" source={path('country')} />
          <TextField label="Date of Birth" source={path('date_of_birth')} />
          <TextField label="Documents" source={path('documents')} />
          <TextField label="Email Address" source={path('email_address')} />
          <TextField label="Eyes" source={path('eyes')} />
          <TextField label="Fax" source={path('fax')} />
          <TextField label="Full Name" source={path('full_name')} />
          <TextField label="GRT" source={path('grt')} />
          <TextField label="Hair" source={path('hair')} />
          <TextField label="Hash" source={path('hash')} />
          <TextField label="Height" source={path('height')} />
          <TextField label="Image URL" source={path('image_url')} />
          <TextField label="Languages" source={path('languages')} />
          <TextField label="Legal Basis" source={path('legal_basis')} />
          <TextField label="Listing Date" source={path('listing_date')} />
          <TextField label="Marks" source={path('marks')} />
          <TextField label="Name ID" source={path('name_id')} />
          <TextField label="Offense" source={path('offense')} />
          <TextField label="Official Title" source={path('official_title')} />
          <TextField label="Original ID" source={path('original_id')} />
          <TextField label="Page URL" source={path('page_url')} />
          <TextField label="Phone" source={path('phone')} />
          <TextField label="Place of Birth" source={path('place_of_birth')} />
          <TextField label="Political Party" source={path('political_party')} />
          <TextField label="Program" source={path('program')} />
          <TextField label="Remarks" source={path('remarks')} />
          <TextField label="Score" source={path('score')} />
          <TextField label="Sex" source={path('sex')} />
          <TextField label="Source" source={path('source')} />
          <TextField label="TIN" source={path('tin')} />
          <TextField label="Title" source={path('title')} />
          <TextField label="Tonnage" source={path('tonnage')} />
          <TextField label="Type" source={path('type')} />
          <TextField label="User ID" source={path('user_id')} />
          <TextField label="Vessel Flag" source={path('vessel_flag')} />
          <TextField label="Vessel Owner" source={path('vessel_owner')} />
          <TextField label="Vessel Type" source={path('vessel_type')} />
          <TextField label="Wanted By" source={path('wanted_by')} />
          <TextField label="Website" source={path('website')} />
          <TextField label="Weight" source={path('weight')} />
        </MainDatagridStyled>
      </ReferenceManyField>
    </Tab>
  );
};

export default WatchlistRecordsTab;
